import type { ApiResponse } from 'apisauce';
import type { Api } from './api';
import { getGeneralApiProblem } from './api-problem';

export class BookmarkApi{
    private api: Api;

    constructor(api: Api) {
        this.api = api;
    }

    async toggleBookmark(clientId:number, requestId:number): Promise<any>{
        try{
            const response: ApiResponse<any> = await this.api.apisauce.post(
                `api/bookmark/${clientId}/${requestId}`                
            );

            if(!response.ok){
                const problem = getGeneralApiProblem(response);
                if(problem) return problem;      
            }
          
            console.log(response);
            return {kind:"ok"};

        }catch(e){
            return {kind: "bad-data"};
        }
    }
}